export function formatManagementMinutes (value) {
  const numeric = Number(value)
  if (!Number.isFinite(numeric) || numeric <= 0) return '00:00'
  const rounded = Math.max(0, Math.round(numeric))
  const hours = Math.floor(rounded / 60)
  const minutes = String(rounded % 60).padStart(2, '0')
  return `${String(hours).padStart(2, '0')}:${minutes}`
}

export function formatManagementMoney (value) {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return '¥0'
  return `¥${Math.round(numeric).toLocaleString('ja-JP')}`
}

export function formatManagementPercent (value) {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return '0.0%'
  return `${numeric.toFixed(1)}%`
}

export function formatManagementDays (value) {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return '0日'
  return `${Number.isInteger(numeric) ? numeric : numeric.toFixed(1)}日`
}

export function formatManagementYearMonth (value) {
  const text = String(value || '')
  if (!/^\d{6}$/.test(text)) return text
  return `${text.substring(0, 4)}年${Number(text.substring(4, 6))}月`
}

export function compactManagementYearMonth (value) {
  const text = String(value || '')
  if (!/^\d{6}$/.test(text)) return text
  return `${Number(text.substring(4, 6))}月`
}

export function heatmapStatusLabel (status) {
  return ({
    PROJECT: 'PJ',
    PARTIAL_LEAVE: '半休',
    LEAVE: '休',
    UNASSIGNED: '未',
    EMPTY: '—'
  })[status] || '—'
}

export function heatmapStatusTone (status) {
  return ({
    PROJECT: 'project',
    PARTIAL_LEAVE: 'partial',
    LEAVE: 'leave',
    UNASSIGNED: 'unassigned',
    EMPTY: 'empty'
  })[status] || 'empty'
}

export function financialSourceLabel (source) {
  return ({
    ACTUAL: '実績',
    MIXED: '実績＋予測',
    FORECAST: '予測',
    EMPTY: 'データなし'
  })[source] || 'データなし'
}

export function financialSourceTone (source) {
  return ({
    ACTUAL: 'actual',
    MIXED: 'mixed',
    FORECAST: 'forecast',
    EMPTY: 'empty'
  })[source] || 'empty'
}

export function clampManagementPercent (value) {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return 0
  return Math.min(100, Math.max(0, numeric))
}

export function isManagementAuthority (value) {
  const normalized = String(value || '').trim().toLowerCase()
  return normalized === 'admin' || normalized === 'clerk'
}

export function isAdminAuthority (value) {
  return String(value || '').trim().toLowerCase() === 'admin'
}
